module.exports = __webpack_public_path__ + "static/logo-157ec074c416f84d786f1ad5fa3f083d.png";